import React from "react";
import Seo from "@/components/Seo";
import UaeHero from "@/components/marketing/uae/UaeHero";
import UaeTrustBadges from "@/components/marketing/uae/UaeTrustBadges";
import UaeServices from "@/components/marketing/uae/UaeServices";
import UaePlacements from "@/components/marketing/uae/UaePlacements";
import UaeNewswires from "@/components/marketing/uae/UaeNewswires";
import UaeWhyUs from "@/components/marketing/uae/UaeWhyUs";
import UaeFAQ from "@/components/marketing/uae/UaeFAQ";
import HowItWorksLedger from "@/components/marketing/service/HowItWorksLedger";
import CTASection from "@/components/marketing/CTASection";
import Reveal from "@/components/marketing/Reveal";

const STEPS = [
  { title: "Choose your channels", desc: "Pick journalist outreach, newswire, guaranteed placements, or a curated package for the UAE." },
  { title: "Send us your release", desc: "Submit your announcement in Arabic, English, or both. We handle translation if needed." },
  { title: "We distribute", desc: "Our team pitches, syndicates, or places your story across the selected UAE channels, same-day submission." },
  { title: "Get your report", desc: "You receive a full pickup report with live published links showing exactly where your story landed." },
];

export default function Uae() {
  return (
    <div className="bg-canvas">
      <Seo
        title="Press Release Distribution UAE | Digital24"
        description="Distribute your press release across UAE media. Guaranteed placements in Khaleej Times, Gulf News and more, newswires from $475, transparent pricing. Published or refunded."
      />
      <UaeHero />
      <UaeTrustBadges />
      <Reveal variant="card">
        <UaeServices />
      </Reveal>
      <Reveal variant="card">
        <UaePlacements />
      </Reveal>
      <Reveal variant="card">
        <UaeNewswires />
      </Reveal>
      <Reveal variant="card">
        <UaeWhyUs />
      </Reveal>
      <HowItWorksLedger
        steps={STEPS}
        tag="HOW IT WORKS"
        title="How UAE distribution works"
      />
      <Reveal variant="card">
        <UaeFAQ />
      </Reveal>
      <CTASection
        eyebrow="GET STARTED"
        headline="Ready to get your story into UAE media?"
        subtitle="Pick your channels and our team handles the rest. Distribution across UAE media, newswires, and journalists."
        primaryTo="/register"
      />
    </div>
  );
}